export enum CONSTANT_URLS {
  LABOR_ANALYTICS = 'https://www.cbre.com/services/transform-business-outcomes/consulting/labor-analytics',
  OCCUPIER = 'https://www.cbre.com/real-estate-services/occupier/labor-analytics'
}
